import { useState, useMemo } from 'react';
import { MapPin, Star, CheckCircle, Filter, X, ChevronDown, ArrowRight, Accessibility, Car, Utensils, Wifi, HeartPulse, Calendar, Users } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

// ─── SAMPLE DATA ──────────────────────────────────────────────────────────────
const STAYS = [
  {
    id: 1,
    title: 'Bien-être & médina, week-end Marrakech',
    city: 'marrakech', pays: 'maroc', type: 'cle_en_main',
    category: 'Bien-être & Culture',
    duration: '3 nuits', nuits: 3,
    pmr: true, selection: false,
    stars: 4,
    price: 1220,
    start_date: '2026-11-07', end_date: '2026-11-10',
    status: 'ouvert',
    amenities: ['pmr', 'transport', 'repas', 'referent'],
    image: 'https://images.pexels.com/photos/3889843/pexels-photo-3889843.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800&h=600',
    desc: 'Riad accessible en plein cœur de la médina. Hammam adapté, jardins, méditation du matin.',
  },
  {
    id: 2,
    title: 'Sérénité atlantique, séjour répit Agadir',
    city: 'agadir', pays: 'maroc', type: 'cle_en_main',
    category: 'Mer & Détente',
    duration: '7 nuits', nuits: 7,
    pmr: true, selection: true,
    stars: 5,
    price: 1890,
    start_date: '2026-11-14', end_date: '2026-11-21',
    status: 'ouvert',
    amenities: ['pmr', 'transport', 'repas', 'soins', 'referent'],
    image: 'https://images.pexels.com/photos/30557503/pexels-photo-30557503.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800&h=600',
    desc: 'Hôtel 4★ en front de mer. Plage accessible, activités douces, accompagnement infirmier 24/7.',
  },
  {
    id: 3,
    title: 'Marrakech & Atlas, immersion culturelle',
    city: 'marrakech', pays: 'maroc', type: 'cle_en_main',
    category: 'Découverte & Excursions',
    duration: '7 nuits', nuits: 7,
    pmr: true, selection: true,
    stars: 5,
    price: 2920,
    start_date: '2026-11-04', end_date: '2026-11-11',
    status: 'ouvert',
    amenities: ['pmr', 'transport', 'repas', 'soins', 'referent', 'wifi'],
    image: 'https://images.unsplash.com/photo-1597212618440-806262de4f6b?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    desc: 'Panoramas de l\'Atlas, riads d\'exception, guide local dédié. Un séjour entre émerveillement et douceur.',
  },
  {
    id: 4,
    title: 'Agadir resort, détente balnéaire & spa',
    city: 'agadir', pays: 'maroc', type: 'cle_en_main',
    category: 'Mer & Bien-être',
    duration: '6 nuits', nuits: 6,
    pmr: true, selection: false,
    stars: 4,
    price: 1650,
    start_date: '2026-12-05', end_date: '2026-12-11',
    status: 'ouvert',
    amenities: ['pmr', 'transport', 'repas', 'referent'],
    image: 'https://images.pexels.com/photos/35166170/pexels-photo-35166170.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800&h=600',
    desc: 'Complexe hôtelier PMR certifié. Piscine adaptée, spa, accès plage directement depuis le resort.',
  },
  {
    id: 5,
    title: 'Jardins secrets & artisanat de Marrakech',
    city: 'marrakech', pays: 'maroc', type: 'a_la_carte',
    category: 'Culture & Artisanat',
    duration: '4 nuits', nuits: 4,
    pmr: true, selection: false,
    stars: 4,
    price: 1450,
    start_date: '2026-11-21', end_date: '2026-11-25',
    status: 'ouvert',
    amenities: ['pmr', 'transport', 'repas'],
    image: 'https://images.pexels.com/photos/3889843/pexels-photo-3889843.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800&h=600',
    desc: 'Ateliers poterie, teinturerie, visite des jardins Majorelle. Un itinéraire fait main, à votre rythme.',
  },
  {
    id: 6,
    title: 'Agadir, escapade balnéaire courte',
    city: 'agadir', pays: 'maroc', type: 'en_autonomie',
    category: 'Mer & Nature',
    duration: '3 nuits', nuits: 3,
    pmr: true, selection: false,
    stars: 3,
    price: 890,
    start_date: '2026-12-12', end_date: '2026-12-15',
    status: 'ouvert',
    amenities: ['pmr', 'transport'],
    image: 'https://images.unsplash.com/photo-1570133435807-5feefeb2d196?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    desc: 'Formule légère pour découvrir Agadir en toute liberté. Hébergement adapté, transfert aéroport inclus.',
  },
  {
    id: 7,
    title: 'Agadir & Souss, arômes & dunes roses',
    city: 'agadir', pays: 'maroc', type: 'en_autonomie',
    category: 'Nature & Terroir',
    duration: '4 nuits', nuits: 4,
    pmr: false, selection: false,
    stars: 3,
    price: 1090,
    start_date: '2026-12-19', end_date: '2026-12-23',
    status: 'ouvert',
    amenities: ['transport', 'repas'],
    image: 'https://images.pexels.com/photos/30557503/pexels-photo-30557503.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800&h=600',
    desc: 'Arganiers en fleurs, dunes roses du Souss, marchés de saveurs — une escapade sensorielle loin du tourisme de masse.',
  },
  {
    id: 8,
    title: 'Marrakech, riads & bien-être intégral',
    city: 'marrakech', pays: 'maroc', type: 'cle_en_main',
    category: 'Bien-être & Spa',
    duration: '5 nuits', nuits: 5,
    pmr: true, selection: true,
    stars: 5,
    price: 2320,
    start_date: '2026-12-01', end_date: '2026-12-06',
    status: 'inscriptions_closes',
    amenities: ['pmr', 'transport', 'repas', 'soins', 'referent', 'wifi'],
    image: 'https://images.pexels.com/photos/33279021/pexels-photo-33279021.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800&h=600',
    desc: 'L\'expérience ultime M-CareLink : 5 étoiles, hammam privatif, yoga, diététicien, médecin référent.',
  },
  {
    id: 9,
    title: 'Agadir & Souss, nature & saveurs',
    city: 'agadir', pays: 'maroc', type: 'a_la_carte',
    category: 'Nature & Gastronomie',
    duration: '4 nuits', nuits: 4,
    pmr: true, selection: false,
    stars: 4,
    price: 1320,
    start_date: '2026-12-19', end_date: '2026-12-23',
    status: 'ouvert',
    amenities: ['pmr', 'transport', 'repas'],
    image: 'https://images.pexels.com/photos/30557503/pexels-photo-30557503.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800&h=600',
    desc: 'Arganiers, marchés de saveurs, dunes roses. Un parcours sensoriel entre mer et désert dans la région du Souss.',
  },
  {
    id: 10,
    title: 'Agadir, yoga & mer, retraite douce',
    city: 'agadir', pays: 'maroc', type: 'cle_en_main',
    category: 'Bien-être & Sport doux',
    duration: '5 nuits', nuits: 5,
    pmr: true, selection: false,
    stars: 4,
    price: 1620,
    start_date: '2027-01-09', end_date: '2027-01-14',
    status: 'ouvert',
    amenities: ['pmr', 'transport', 'repas', 'referent'],
    image: 'https://images.pexels.com/photos/35166170/pexels-photo-35166170.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800&h=600',
    desc: 'Sessions yoga en bord de mer, piscine PMR, massages bien-être. Une retraite douce pour l\'aidant et son proche.',
  },
  {
    id: 11,
    title: 'Marrakech, riads & souks — week-end',
    city: 'marrakech', pays: 'maroc', type: 'en_autonomie',
    category: 'Escapade & Shopping',
    duration: '3 nuits', nuits: 3,
    pmr: false, selection: false,
    stars: 4,
    price: 980,
    start_date: '2026-11-27', end_date: '2026-11-30',
    status: 'inscriptions_closes',
    amenities: ['transport', 'referent'],
    image: 'https://images.unsplash.com/photo-1570133435529-62359fac701b?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    desc: 'La Marrakech authentique : Place Djemaa el-Fna, artisans, souks couverts. Hébergement central bien noté.',
  },
  {
    id: 12,
    title: 'Agadir, répit total en resort PMR',
    city: 'agadir', pays: 'maroc', type: 'cle_en_main',
    category: 'Répit & Santé',
    duration: '7 nuits', nuits: 7,
    pmr: true, selection: false,
    stars: 4,
    price: 1980,
    start_date: '2027-01-16', end_date: '2027-01-23',
    status: 'ouvert',
    amenities: ['pmr', 'transport', 'repas', 'soins', 'referent'],
    image: 'https://images.unsplash.com/photo-1570133435573-fcb96d98f69b?crop=entropy&cs=srgb&fm=jpg&w=800&q=80',
    desc: 'La formule conçue pour les proches à forte dépendance : soins 24/7, piscine PMR, kinésithérapeute sur place.',
  },
];

const TYPE_LABELS = {
  cle_en_main: 'Clé en main',
  en_autonomie: 'En autonomie',
  a_la_carte: 'À la carte',
};

const AMENITY_ICONS = {
  pmr: { Icon: Accessibility, label: 'PMR' },
  transport: { Icon: Car, label: 'Transport' },
  repas: { Icon: Utensils, label: 'Repas' },
  soins: { Icon: HeartPulse, label: 'Soins' },
  referent: { Icon: Users, label: 'Référent' },
  wifi: { Icon: Wifi, label: 'Wifi' },
};

function StayCard({ stay }) {
  const fmt = (d) => new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  return (
    <div className="group bg-white rounded-2xl border border-border/60 overflow-hidden shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300" data-testid={`stay-card-${stay.id}`}>
      {/* Image */}
      <div className="relative h-48 overflow-hidden">
        <img src={stay.image} alt={stay.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute top-3 left-3 flex gap-1.5">
          <span className="text-xs font-body font-medium bg-primary/90 text-white rounded-full px-2.5 py-1 backdrop-blur-sm">
            {TYPE_LABELS[stay.type]}
          </span>
          {stay.selection && (
            <span className="text-xs font-body font-medium bg-secondary text-foreground rounded-full px-2.5 py-1">
              ✦ Sélection
            </span>
          )}
        </div>
        <div className="absolute top-3 right-3">
          <span className={`text-xs font-body font-medium rounded-full px-2.5 py-1 ${
            stay.status === 'ouvert' ? 'bg-green-100 text-green-700' : 'bg-red-100/90 text-red-700'
          }`}>
            {stay.status === 'ouvert' ? 'Ouvert' : 'Inscriptions closes'}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-5">
        {/* Stars + location */}
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-1">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className={`w-3 h-3 ${i < stay.stars ? 'fill-secondary text-secondary' : 'text-muted-foreground/30'}`} />
            ))}
          </div>
          <div className="flex items-center gap-1 text-xs text-muted-foreground font-body">
            <MapPin className="w-3 h-3" />
            {stay.city.charAt(0).toUpperCase() + stay.city.slice(1)}, Maroc
          </div>
        </div>

        {/* Category */}
        <p className="text-[11px] uppercase tracking-[0.12em] text-accent font-body mb-1.5">{stay.category}</p>

        {/* Title */}
        <h3 className="font-heading text-base font-medium text-foreground leading-tight mb-2 line-clamp-2">{stay.title}</h3>
        <p className="text-xs text-muted-foreground font-body leading-relaxed mb-3 line-clamp-2">{stay.desc}</p>

        {/* Amenities */}
        <div className="flex flex-wrap gap-1.5 mb-3">
          {stay.amenities.slice(0, 4).map(a => {
            const cfg = AMENITY_ICONS[a];
            if (!cfg) return null;
            const { Icon, label } = cfg;
            return (
              <div key={a} className="flex items-center gap-1 text-[10px] font-body bg-muted/60 text-muted-foreground rounded-full px-2 py-0.5">
                <Icon className="w-2.5 h-2.5" /> {label}
              </div>
            );
          })}
          {stay.amenities.length > 4 && (
            <div className="text-[10px] font-body bg-muted/60 text-muted-foreground rounded-full px-2 py-0.5">
              +{stay.amenities.length - 4}
            </div>
          )}
        </div>

        {/* Date + duration */}
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground font-body mb-4">
          <Calendar className="w-3.5 h-3.5 flex-shrink-0" />
          <span>Du {fmt(stay.start_date)} au {fmt(stay.end_date)}</span>
          <span className="text-border">·</span>
          <span className="font-medium text-foreground">{stay.duration}</span>
        </div>

        {/* Price + CTA */}
        <div className="flex items-center justify-between pt-3 border-t border-border/60">
          <div>
            <p className="text-[10px] text-muted-foreground font-body">À partir de</p>
            <p className="font-heading text-lg font-semibold text-primary">
              {stay.price.toLocaleString('fr-FR')} € <span className="text-xs font-body font-normal text-muted-foreground">/pers.</span>
            </p>
          </div>
          <Link to="/demander-un-sejour" data-testid={`stay-cta-${stay.id}`}>
            <Button size="sm" className="rounded-full bg-accent hover:bg-accent/90 text-white font-body gap-1.5 px-4 text-xs">
              Découvrir <ArrowRight className="w-3 h-3" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

function FilterGroup({ title, children }) {
  const [open, setOpen] = useState(true);
  return (
    <div className="border-b border-border/60 pb-4 mb-4 last:border-0 last:mb-0">
      <button onClick={() => setOpen(o => !o)} className="flex items-center justify-between w-full mb-3 group">
        <span className="text-[10px] font-body font-semibold uppercase tracking-[0.18em] text-muted-foreground group-hover:text-foreground transition-colors">{title}</span>
        <ChevronDown className={`w-3.5 h-3.5 text-muted-foreground transition-transform ${open ? '' : '-rotate-90'}`} />
      </button>
      {open && children}
    </div>
  );
}

export default function StaysPage() {
  const [filters, setFilters] = useState({ type: 'tous', pmr: false, pays: 'tous', ville: 'toutes' });
  const [mobileFilters, setMobileFilters] = useState(false);

  const setFilter = (key, value) => setFilters(f => ({ ...f, [key]: value }));

  const filtered = useMemo(() => STAYS.filter(s => {
    if (filters.type !== 'tous' && s.type !== filters.type) return false;
    if (filters.pmr && !s.pmr) return false;
    if (filters.pays !== 'tous' && s.pays !== filters.pays) return false;
    if (filters.ville !== 'toutes' && s.city !== filters.ville) return false;
    return true;
  }), [filters]);

  const counts = (key, val) => STAYS.filter(s => s[key] === val).length;
  const cityCount = (c) => STAYS.filter(s => s.city === c).length;
  const activeFiltersCount = [
    filters.type !== 'tous', filters.pmr, filters.pays !== 'tous', filters.ville !== 'toutes'
  ].filter(Boolean).length;

  const resetFilters = () => setFilters({ type: 'tous', pmr: false, pays: 'tous', ville: 'toutes' });

  const FilterPanel = () => (
    <div className="space-y-0">
      {/* Type de séjour */}
      <FilterGroup title="Type de séjour">
        {[
          { val: 'tous', label: 'Tous les séjours', count: STAYS.length },
          { val: 'cle_en_main', label: 'Clé en main', count: counts('type', 'cle_en_main') },
          { val: 'en_autonomie', label: 'En autonomie', count: counts('type', 'en_autonomie') },
          { val: 'a_la_carte', label: 'À la carte', count: counts('type', 'a_la_carte') },
        ].map(({ val, label, count }) => (
          <label key={val} className="flex items-center justify-between py-1 cursor-pointer group">
            <div className="flex items-center gap-2">
              <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${
                filters.type === val ? 'border-accent bg-accent' : 'border-border/60 group-hover:border-accent/50'
              }`}>
                {filters.type === val && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
              </div>
              <span className={`text-sm font-body transition-colors ${filters.type === val ? 'text-foreground font-medium' : 'text-muted-foreground group-hover:text-foreground'}`}>
                {label}
              </span>
            </div>
            <span className={`text-xs font-body rounded-full px-2 py-0.5 ${filters.type === val ? 'bg-accent/10 text-accent' : 'bg-muted text-muted-foreground'}`}>
              {count}
            </span>
            <input type="radio" className="sr-only" checked={filters.type === val} onChange={() => setFilter('type', val)} />
          </label>
        ))}
      </FilterGroup>

      {/* PMR */}
      <FilterGroup title="Accessibilité PMR">
        <label className="flex items-center justify-between cursor-pointer group py-1">
          <span className={`text-sm font-body ${filters.pmr ? 'text-foreground font-medium' : 'text-muted-foreground'}`}>
            Uniquement PMR
          </span>
          <div
            onClick={() => setFilter('pmr', !filters.pmr)}
            role="switch"
            aria-checked={filters.pmr}
            tabIndex={0}
            data-testid="pmr-toggle"
            className={`w-10 h-5 rounded-full relative transition-colors cursor-pointer ${filters.pmr ? 'bg-accent' : 'bg-muted-foreground/30'}`}
          >
            <div className={`w-4 h-4 rounded-full bg-white absolute top-0.5 transition-all ${filters.pmr ? 'left-5' : 'left-0.5'} shadow-sm`} />
          </div>
        </label>
      </FilterGroup>

      {/* Pays */}
      <FilterGroup title="Pays">
        {[
          { val: 'tous', label: 'Tous', count: STAYS.length },
          { val: 'maroc', label: 'Maroc', count: counts('pays', 'maroc') },
        ].map(({ val, label, count }) => (
          <label key={val} className="flex items-center justify-between py-1 cursor-pointer group">
            <div className="flex items-center gap-2">
              <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${
                filters.pays === val ? 'border-accent bg-accent' : 'border-border/60 group-hover:border-accent/50'
              }`}>
                {filters.pays === val && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
              </div>
              <span className={`text-sm font-body transition-colors ${filters.pays === val ? 'text-foreground font-medium' : 'text-muted-foreground group-hover:text-foreground'}`}>
                {label}
              </span>
            </div>
            <span className={`text-xs font-body rounded-full px-2 py-0.5 ${filters.pays === val ? 'bg-accent/10 text-accent' : 'bg-muted text-muted-foreground'}`}>
              {count}
            </span>
            <input type="radio" className="sr-only" checked={filters.pays === val} onChange={() => setFilter('pays', val)} />
          </label>
        ))}
      </FilterGroup>

      {/* Ville Maroc */}
      <FilterGroup title="Ville (Maroc)">
        {[
          { val: 'toutes', label: 'Toutes', count: STAYS.filter(s => s.pays === 'maroc').length },
          { val: 'marrakech', label: 'Marrakech', count: cityCount('marrakech') },
          { val: 'agadir', label: 'Agadir', count: cityCount('agadir') },
        ].map(({ val, label, count }) => (
          <label key={val} className="flex items-center justify-between py-1 cursor-pointer group">
            <div className="flex items-center gap-2">
              <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${
                filters.ville === val ? 'border-accent bg-accent' : 'border-border/60 group-hover:border-accent/50'
              }`}>
                {filters.ville === val && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
              </div>
              <span className={`text-sm font-body transition-colors ${filters.ville === val ? 'text-foreground font-medium' : 'text-muted-foreground group-hover:text-foreground'}`}>
                {label}
              </span>
            </div>
            <span className={`text-xs font-body rounded-full px-2 py-0.5 ${filters.ville === val ? 'bg-accent/10 text-accent' : 'bg-muted text-muted-foreground'}`}>
              {count}
            </span>
            <input type="radio" className="sr-only" checked={filters.ville === val} onChange={() => setFilter('ville', val)} />
          </label>
        ))}
      </FilterGroup>
    </div>
  );

  return (
    <div className="min-h-screen bg-background pt-18" data-testid="stays-page">
      {/* Page Header */}
      <div className="bg-primary text-primary-foreground py-10 px-4 sm:px-8">
        <div className="max-w-7xl mx-auto">
          <p className="text-xs font-body uppercase tracking-[0.2em] text-secondary mb-2">Marrakech · Agadir</p>
          <h1 className="font-heading font-light text-4xl md:text-5xl text-white mb-3">Nos séjours</h1>
          <p className="text-sm text-primary-foreground/65 font-body max-w-xl">
            {STAYS.length} séjours coordonnés par M-CareLink — hébergement adapté, transport PMR et référent local inclus.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Mobile filter button */}
        <div className="lg:hidden mb-5 flex items-center justify-between">
          <p className="text-sm font-body text-muted-foreground">
            <strong className="text-foreground">{filtered.length}</strong> séjour{filtered.length > 1 ? 's' : ''}
          </p>
          <Button
            variant="outline"
            size="sm"
            className="rounded-full gap-2 font-body"
            onClick={() => setMobileFilters(true)}
            data-testid="mobile-filters-btn"
          >
            <Filter className="w-4 h-4" /> Filtres
            {activeFiltersCount > 0 && (
              <span className="w-4 h-4 rounded-full bg-accent text-white text-[10px] flex items-center justify-center">{activeFiltersCount}</span>
            )}
          </Button>
        </div>

        <div className="flex gap-8">
          {/* Sidebar Filters — Desktop */}
          <aside className="hidden lg:block w-64 flex-shrink-0 sticky top-24 self-start" data-testid="filter-sidebar">
            <div className="bg-white rounded-2xl border border-border/60 shadow-sm p-5">
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-2">
                  <Filter className="w-4 h-4 text-primary" />
                  <span className="font-body font-semibold text-sm text-foreground">Filtres</span>
                  {activeFiltersCount > 0 && (
                    <span className="w-5 h-5 rounded-full bg-accent text-white text-[10px] flex items-center justify-center">{activeFiltersCount}</span>
                  )}
                </div>
                {activeFiltersCount > 0 && (
                  <button onClick={resetFilters} className="text-xs text-accent font-body hover:underline" data-testid="reset-filters">
                    Réinitialiser
                  </button>
                )}
              </div>
              <FilterPanel />
            </div>
          </aside>

          {/* Mobile filter drawer */}
          {mobileFilters && (
            <div className="fixed inset-0 z-50 lg:hidden">
              <div className="absolute inset-0 bg-black/50" onClick={() => setMobileFilters(false)} />
              <div className="absolute right-0 top-0 bottom-0 w-80 bg-white shadow-2xl p-6 overflow-y-auto">
                <div className="flex items-center justify-between mb-6">
                  <span className="font-body font-semibold text-lg">Filtres</span>
                  <button onClick={() => setMobileFilters(false)}>
                    <X className="w-5 h-5 text-muted-foreground" />
                  </button>
                </div>
                <FilterPanel />
                <Button onClick={() => setMobileFilters(false)} className="w-full rounded-full mt-4 bg-accent text-white font-body">
                  Voir les {filtered.length} séjours
                </Button>
              </div>
            </div>
          )}

          {/* Cards Grid */}
          <div className="flex-1 min-w-0">
            {/* Results header */}
            <div className="flex items-center justify-between mb-5">
              <p className="text-sm font-body text-muted-foreground">
                <strong className="text-foreground">{filtered.length}</strong> séjour{filtered.length > 1 ? 's' : ''} disponible{filtered.length > 1 ? 's' : ''}
              </p>
              {activeFiltersCount > 0 && (
                <div className="flex items-center gap-2 flex-wrap">
                  {filters.type !== 'tous' && (
                    <span className="text-xs bg-accent/10 text-accent rounded-full px-3 py-1 font-body flex items-center gap-1.5" data-testid="chip-type">
                      {TYPE_LABELS[filters.type]}
                      <button onClick={() => setFilter('type', 'tous')} data-testid="chip-type-remove"><X className="w-3 h-3" /></button>
                    </span>
                  )}
                  {filters.pmr && (
                    <span className="text-xs bg-accent/10 text-accent rounded-full px-3 py-1 font-body flex items-center gap-1.5" data-testid="chip-pmr">
                      PMR <button onClick={() => setFilter('pmr', false)} data-testid="chip-pmr-remove"><X className="w-3 h-3" /></button>
                    </span>
                  )}
                  {filters.ville !== 'toutes' && (
                    <span className="text-xs bg-accent/10 text-accent rounded-full px-3 py-1 font-body flex items-center gap-1.5" data-testid="chip-ville">
                      {filters.ville.charAt(0).toUpperCase() + filters.ville.slice(1)}
                      <button onClick={() => setFilter('ville', 'toutes')} data-testid="chip-ville-remove"><X className="w-3 h-3" /></button>
                    </span>
                  )}
                  {filters.pays !== 'tous' && (
                    <span className="text-xs bg-accent/10 text-accent rounded-full px-3 py-1 font-body flex items-center gap-1.5" data-testid="chip-pays">
                      {filters.pays.charAt(0).toUpperCase() + filters.pays.slice(1)}
                      <button onClick={() => setFilter('pays', 'tous')} data-testid="chip-pays-remove"><X className="w-3 h-3" /></button>
                    </span>
                  )}
                </div>
              )}
            </div>

            {filtered.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-24 text-center">
                <div className="w-14 h-14 rounded-2xl bg-muted/50 flex items-center justify-center mb-4">
                  <Filter className="w-6 h-6 text-muted-foreground/40" />
                </div>
                <p className="font-heading text-xl text-muted-foreground mb-2">Aucun séjour trouvé</p>
                <p className="text-sm text-muted-foreground/60 font-body mb-5">Essayez de modifier vos critères</p>
                <Button variant="outline" onClick={resetFilters} className="rounded-full font-body">Réinitialiser les filtres</Button>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5" data-testid="stays-grid">
                {filtered.map(stay => <StayCard key={stay.id} stay={stay} />)}
              </div>
            )}

            {/* Bottom CTA */}
            <div className="mt-12 bg-primary rounded-2xl p-8 text-center text-primary-foreground">
              <p className="text-xs font-body uppercase tracking-[0.2em] text-secondary mb-3">Séjour sur mesure</p>
              <h3 className="font-heading font-light text-2xl text-white mb-3">Vous ne trouvez pas votre séjour idéal ?</h3>
              <p className="text-sm font-body text-primary-foreground/65 mb-5 max-w-md mx-auto">
                Décrivez votre situation, vos contraintes et vos envies. Notre équipe construit un séjour personnalisé sous 48h.
              </p>
              <Link to="/demander-un-sejour">
                <Button className="rounded-full bg-accent hover:bg-accent/90 text-white font-body gap-2 px-6">
                  Faire ma demande sur mesure <ArrowRight className="w-4 h-4" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
